<script>
    import { createEventDispatcher } from 'svelte';
    import MultiFieldInput from './MultiFieldInput.svelte';
    import MultiFieldAsset from './MultiFieldAsset.svelte';

    export let mtappVars;
    export let item;

    const dispatch = createEventDispatcher();
    function triggerInputChange() {
        dispatch('inputchange');
    }
</script>

<div data-handle={item.type}>
    <div class="mt-table--outline">
        <table class="table mt-table mtapp-mf-table-vertical">
            <tbody>
                {#each item.data as cell (cell.id)}
                    <tr>
                        <th class="align-middle" scope="row">{cell.label}</th>
                        <td class="align-middle">
                            {#if cell.description}
                                <p class="mt-0 mb-2">
                                    <small>{@html cell.description}</small>
                                </p>
                            {/if}
                            {#if ['text', 'email', 'url', 'tel', 'password', 'number', 'datepicker', 'date', 'time', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'textarea', 'code', 'tinymce', 'select', 'select-multiple', 'checkbox', 'radio'].includes(cell.type)}
                                <MultiFieldInput mtappVars={mtappVars} item={cell} on:inputchange={triggerInputChange} />
                            {:else if ['asset', 'image'].includes(cell.type)}
                                <MultiFieldAsset mtappVars={mtappVars} id={cell.id} item={cell} on:inputchange={triggerInputChange} />
                            {/if}
                            {#if cell.help}
                                <div class="mt-2 mb-0 text-muted">
                                    <small>{@html cell.help}</small>
                                </div>
                            {/if}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>
